import { useState, useEffect } from 'react';
import { initViewportHeightListeners, getViewportHeight } from '../utils/viewportHeight';

interface ViewportHeight {
  vh: number;
  dvh: number;
  lvh: number;
  svh: number;
}

const useViewportHeight = (): ViewportHeight => {
  const [viewportHeight, setViewportHeight] = useState<ViewportHeight>({
    vh: 100,
    dvh: 100,
    lvh: 100,
    svh: 100
  });

  useEffect(() => {
    const updateViewportHeight = () => {
      // Получаем высоту viewport
      const vh = getViewportHeight();

      // Вычисляем процент от общей высоты экрана
      const vhPercent = (vh / window.screen.height) * 100;

      setViewportHeight({
        vh: vhPercent,
        dvh: vhPercent,
        lvh: vhPercent,
        svh: vhPercent
      });
    };

    // Инициализируем слушатели и получаем функцию очистки
    const cleanup = initViewportHeightListeners();

    // Обновляем состояние при изменении высоты
    const handleResize = () => {
      updateViewportHeight();
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', () => {
      setTimeout(handleResize, 100);
    });

    // Инициализируем сразу
    updateViewportHeight();

    return () => {
      cleanup();
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return viewportHeight;
};

export default useViewportHeight;
